/* global axios */
import ApiClient from '../ApiClient';

class NexceoAiWorkforceAPI extends ApiClient {
  constructor() {
    super('nexceo/ai_workforce', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  toggleGlobal(enabled) {
    return axios.post(`${this.url}/toggle_global`, { enabled });
  }

  toggle(id) {
    return axios.post(`${this.url}/${id}/toggle`);
  }

  updateRole(id, role) {
    return axios.patch(`${this.url}/${id}/role`, { role });
  }
}

export default new NexceoAiWorkforceAPI();
